module.exports = __webpack_public_path__ + "static/fonts/342F4F_6_0.a23eb0f.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_6_0.ttf
// module id = 109
// module chunks = 3